import React, { Component, Dispatch, createRef } from 'react';
import { Log } from 'ng2-logger';
import { IAction, IAppState } from '../../../../models/action/core';
import { connect } from 'react-redux';
import { Common } from '../../../../core/common';
import SelectClasses from '../../../../components/add-activity/select-classes';
import VideoActivitySettings from './video-activity-settings';
import VideoContentPanel from './video-content';
import ActivitySettings from '../../../../components/add-activity/activity-settings';
import { VideoType } from '../../../../models/enums/VideoType';
import { IAddVideo } from '../../../../models/components/add-activity';
import * as actionTypeVideo from '../../../../models/action/video';
import * as Actions from '../../../../store/actions/video';
import { Formik, FormikActions, FormikProps } from 'formik';
import { Guid } from 'guid-typescript';
import { getValidation } from '../../../../models/validations/activity-video-validation';
import { initSubmitValuesForApi, checkFileUploadEmpty } from '../../../../components/add-activity/add-activity-functions';
import Loading from '../../../../components/loading/loading';
import Moment from 'moment';
import Translator from '../../../../core/i18n';
import { Notification } from '../../../../components/notification/main';
import { Modal, Label } from 'reactstrap';
import { ActivityType, ActivityTypeEnums } from '../../../../models/enums/ActivityType';
import { ISetAssignmentStudentList } from '../../../../models/action/assignment';

const T = Translator.create();
const _logger = Log.create('add-activity-video-modal.tsx');
let _common: Common;
const spinnerId = 'addVideoActivityLoading';

export class AddVideo extends Component<IAddVideo, any> {
    public state = {
        currentTab: !this.props.isProjectSubActivity && !this.props.isSingleClass && this.props.classes?.classes.length > 0 ? '_selectClassTab' : '_videoSettingTab',
        fileInputKey: Guid.create().toString(),
        photoUploadKey: Guid.create().toString(),
        isUploaded: false,
        videoQuestionStatus: true,
        isLoadingProcess: false,
        deletedFile: false
    };
    public modalRootDiv: HTMLElement | null = null;
    private _formElement = createRef<HTMLFormElement>();
    private _selectClassTab = createRef<HTMLAnchorElement>();
    private _videoSettingTab = createRef<HTMLAnchorElement>();
    private _activitySettingTab = createRef<HTMLAnchorElement>();
    private _videoContentTab = createRef<HTMLAnchorElement>();
    private _selectClassTabErrorProperty = ['isCommon', 'selectedClass'];
    private _videoSettingTabErrorProperty = [
        'name',
        'description',
        'isFileUploadEmpty',
        'termWeekIds',
        'datePrerequisiteActivityId',
        'datePrerequisiteActivityHours',
        'completionCriteria',
        'completionCriteriaProgress',
        'fileUploaded',
        'fileEmbed'
    ];
    private _videoContentTabErrorProperty = [];
    private _activitySettingTabErrorProperty = ['datePrerequisiteActivityId', 'datePrerequisiteActivityHours'];

    constructor(props: any) {
        super(props);
        _common = new Common();
        this.onSubmit = this.onSubmit.bind(this);
        this.beforeClickForm = this.beforeClickForm.bind(this);
    }

    public componentDidMount() {
        if (this.props.updateActivityId) {
            if (this.props.updateActivityId) {
                this.props.dispatch(
                    Actions.getVideoActivityAction(
                        {
                            GetActivityType: 1,
                            ActivityId: this.props.updateActivityId,
                            ClassId: this.props.coursePageClassId!,
                            CourseId: this.props.coursePageActivityId!
                        },
                        spinnerId,
                        'get'
                    )
                );
            }
        }
        this.setState({ isUploaded: false });
    }

    componentDidUpdate(prevProps: Readonly<IAddVideo>, prevState: Readonly<any>, snapshot?: any): void {

        if (this.props.updateActivityId) {
            if ((this.props.videoData?.file || this.props.videoData?.fileEmbed) && !this.state.isUploaded) {
                this.setState({ isUploaded: true })
            }
        }

        if (this.state.currentTab !== prevState.currentTab) {
            let modalElement = document.getElementsByClassName("add-activity-modal modal-from-right slideInRight show animated")
            if (modalElement) {
                modalElement[0].scrollTop = 0;
            }

        }
    }

    public detectDuplicateText(arr: any) {
        const seen = new Set(); 
        return arr.filter((item:any, index:any, array:any) => {
          const textValue = item.choiceText;
                if (seen.has(textValue)) {
            return true; 
          } else {
            seen.add(textValue); 
            return false;
          }
        }).map((item:any) => item.choiceText); 
    }
      

    public checkQuestionValidation = (): boolean => {
        let returnValue = true;
        if (this.props.questionData!.questions.length > 0) {

            let valueArr = this.props.questionData!.questions.map(function (item) { return item.showOnSecond });
            let isDuplicate = valueArr.some(function (item, idx) {
                return valueArr.indexOf(item) != idx
            });

            if (isDuplicate) {

                Notification.setNotification(
                    'error',
                    T.t('r_validation_gen_video_duplicated_seconds'),
                    'topRight'
                );
                returnValue = false;

            }

        }
        if (this.props.questionData!.questions.length > 0) {
            this.props.questionData!.questions.forEach((data, index) => {
                if (!data.question) {
                    Notification.setNotification(
                        'error',
                        _common.StringFormat(T.t('r_field_required_videoquestion_questiontext'), [
                            { key: 'questionCount', value: (index + 1).toString() }
                        ]),
                        'topRight'
                    );
                    returnValue = false;
                }
                if (!data.videoTestChoices) {
                    Notification.setNotification(
                        'error',
                        _common.StringFormat(T.t('r_field_required_videoquestion_choices'), [
                            { key: 'questionCount', value: (index + 1).toString() }
                        ]),
                        'topRight'
                    );
                    returnValue = false;
                }
                if (data.videoTestChoices &&  data.videoTestChoices?.length<2) {
                    Notification.setNotification(
                        'error',
                        _common.StringFormat(T.t('r_field_required_videoquestion_min_two_choices'), [
                            { key: 'questionCount', value: (index + 1).toString() }
                        ]),
                        'topRight'
                    );
                    returnValue = false;
                }
                if (data.videoTestChoices && data.videoTestChoices!.length === 0) {
                    Notification.setNotification(
                        'error',
                        _common.StringFormat(T.t('r_field_required_videoquestion_choices'), [
                            { key: 'questionCount', value: (index + 1).toString() }
                        ]),
                        'topRight'
                    );
                    returnValue = false;
                }
                if (data.videoTestChoices && data.videoTestChoices!.length > 0) {
                    data.videoTestChoices!.forEach((dataChoice, indexChoice) => {
                        if (!dataChoice.choiceText) {
                            Notification.setNotification(
                                'error',
                                _common.StringFormat(T.t('r_field_required_videoquestion_choicestext'), [
                                    { key: 'questionCount', value: (index + 1).toString() }
                                ]),
                                'topRight'
                            );
                            returnValue = false;
                        }
                    });

                    if(data.videoTestChoices && data.videoTestChoices.length>1)
                    {
                            let result = this.detectDuplicateText(data.videoTestChoices);
                            if(result.length>0)
                            {
                                Notification.setNotification(
                                    'error',
                                    _common.StringFormat(T.t('r_questionBank_add_questionChoice_duplicate'), [
                                        { key: 'questionCount', value: (index + 1).toString() }
                                    ]),
                                    'topRight'
                                );
                                returnValue = false;
                            }
                    }
                    if (data.videoTestChoices!.filter(f => f.isAnswer).length === 0) {
                        Notification.setNotification(
                            'error',
                            _common.StringFormat(T.t('r_field_required_videoquestion_choiceiscorrect'), [
                                { key: 'questionCount', value: (index + 1).toString() }
                            ]),
                            'topRight'
                        );
                        returnValue = false;
                    }
                }
            });
        } else {
            returnValue = true;
        }
        return returnValue;
    };

    public updateVideoQuestionStatus = (status: boolean) => {
        if (this.state.videoQuestionStatus != status) {
            this.setState({ videoQuestionStatus: status })

        }
    }

    public onSubmit(FormikValues: actionTypeVideo.IVideoInsertData, formikActions: FormikActions<any>) {
        this.setState({ isLoadingProcess: true })
        const values: actionTypeVideo.IVideoInsertData = JSON.parse(JSON.stringify(FormikValues));
        initSubmitValuesForApi(this.props, values, ActivityTypeEnums.Video);

        values.videoType = values.videoType !== VideoType.Local ?
            (
                values.videoType !== VideoType.WithArchiveLink ?
                    _common.getVideoType(values.fileEmbed) : VideoType.WithArchiveLink
            )
            :
            VideoType.Local;

        values.fileEmbed = values.videoType !== VideoType.Local ? values.fileEmbed : '';

        if (this.props.isProjectSubActivity) {
            values.isProjectActivity = this.props.isProjectSubActivity;
            values.isCommon = 1;
            values.projectActivityId = this.props.projectActivityId;
        }
        this.props.dispatch(
            Actions.addVideoGetAction(values, this.props.questionData!, spinnerId, 'get', this.callBackFunction)
        );
    }

    callBackFunction = (value: any) => {
        if (!value) {
            this.setState({ isLoadingProcess: false });
            return;
        }
        if (this.props.isProjectSubActivity) {
            value.termWeekId = this.props.activityCard[0].termWeekIds[0];
            value.isUpdateWeeks = false;
        } else {
            value.termWeekId = _common.findTermWeekIdForRefreshPage(this.props, value);
            value.isUpdateWeeks = true;
        }
        this.props.onRefreshActivityCards(value);
        this.setCloseModal();
        this.setState({ isLoadingProcess: false })
    };

    public async onTabClick(ikParameter: FormikProps<actionTypeVideo.IVideoInsertData>, selectNewTab: string) {
        let lastValidateTab = '';

        if (this._selectClassTab.current?.getAttribute('data-current') === 'true') {
            lastValidateTab = '_selectClassTab';
        } else if (this._videoSettingTab.current!.getAttribute('data-current') === 'true') {
            lastValidateTab = '_videoSettingTab';
        } else if (this._videoContentTab.current!.getAttribute('data-current') === 'true') {
            lastValidateTab = '_videoContentTab';
        } else if (this._activitySettingTab.current!.getAttribute('data-current') === 'true') {
            lastValidateTab = '_activitySettingTab';
        }
        
        if (selectNewTab !== lastValidateTab && lastValidateTab !== '_activitySettingTab') {
            const validateForm = await this.beforeClickForm(ikParameter, false);
            if (validateForm === true) {
                switch (selectNewTab) {
                    case '_selectClassTab': {
                        this._videoSettingTab.current!.setAttribute('data-current', 'false');
                        this._selectClassTab.current?.setAttribute('data-current', 'true');
                        this._videoContentTab.current!.setAttribute('data-current', 'false');
                        this._activitySettingTab.current!.setAttribute('data-current', 'false');
                        this.setState({ currentTab: '_selectClassTab' });
                        break;
                    }
                    case '_videoSettingTab': {
                        this._videoSettingTab.current!.setAttribute('data-current', 'true');
                        this._selectClassTab.current?.setAttribute('data-current', 'false');
                        this._videoContentTab.current!.setAttribute('data-current', 'false');
                        this._activitySettingTab.current!.setAttribute('data-current', 'false');
                        this.setState({ currentTab: '_videoSettingTab' });
                        break;
                    }
                    case '_videoContentTab': {
                        this._videoSettingTab.current!.setAttribute('data-current', 'false');
                        this._selectClassTab.current?.setAttribute('data-current', 'false');
                        this._videoContentTab.current!.setAttribute('data-current', 'true');
                        this._activitySettingTab.current!.setAttribute('data-current', 'false');
                        this.setState({ currentTab: '_videoContentTab' });
                        break;
                    }
                    case '_activitySettingTab': {
                        this._videoSettingTab.current!.setAttribute('data-current', 'false');
                        this._selectClassTab.current?.setAttribute('data-current', 'false');
                        this._videoContentTab.current!.setAttribute('data-current', 'false');
                        this._activitySettingTab.current!.setAttribute('data-current', 'true');
                        this.setState({ currentTab: '_activitySettingTab' });
                        break;
                    }
                    default: {
                        break;
                    }
                }
            }
        } else if (selectNewTab !== lastValidateTab && lastValidateTab === '_activitySettingTab') {
            this._videoSettingTab.current!.setAttribute('data-current', 'false');
            this._selectClassTab.current?.setAttribute('data-current', 'false');
            this._videoContentTab.current!.setAttribute('data-current', 'false');
            this._activitySettingTab.current!.setAttribute('data-current', 'false');

            switch (selectNewTab) {
                case '_selectClassTab': {
                    this._selectClassTab.current?.setAttribute('data-current', 'true');
                    break;
                }
                case '_videoSettingTab': {
                    this._videoSettingTab.current!.setAttribute('data-current', 'true');
                    break;
                }
                case '_videoContentTab': {
                    this._videoContentTab.current!.setAttribute('data-current', 'true');
                    break;
                }
                case '_activitySettingTab': {
                    this._activitySettingTab.current!.setAttribute('data-current', 'true');
                    break;
                }
                default: {
                    break;
                }
            }

            this.setState({ currentTab: selectNewTab });
        }
    }

    returnErrorMessage = (returnData: any, errorProperty: any, errorCount: number, isAcyivitySettingsTab: any) => {
        if(isAcyivitySettingsTab){
            Object.keys(returnData).forEach(key => {
                Notification.setNotification(
                    'error',
                    T.t('r_validation_gen_' + key) + ' - ' + returnData[key],
                    'topRight'
                );
                errorCount++;
            });
        }else{
            Object.keys(returnData).forEach(key => {
                if (errorProperty.find((s: any) => s === key)) {
                    Notification.setNotification(
                        'error',
                        T.t('r_validation_gen_' + key) + ' - ' + returnData[key],
                        'topRight'
                    );
                    errorCount++;
                }
            });
    
        }
        
        return errorCount;
    }

    updateTabStates(nextTab: string) {
        const tabs = ['_selectClassTab', '_videoSettingTab', '_activitySettingTab', '_videoContentTab'];
        tabs.forEach((tab) => {
            const isActive = tab === nextTab;
            (this[tab as keyof this] as React.RefObject<HTMLDivElement>).current?.setAttribute(
                'data-current',
                isActive ? 'true' : 'false'
            );
        });
        this.setState({ currentTab: nextTab });
    }
    processErrorMessages(returnData: any, errorProperty: any, errorCount: number, isFinal: boolean) {
        return this.returnErrorMessage(returnData, errorProperty, errorCount, isFinal);
    }

    handleSelectClassTab(returnData: any, redirect: boolean): number {
        let errorCount = this.processErrorMessages(returnData, this._selectClassTabErrorProperty, 0, false);
    
        if (errorCount === 0 && redirect) {
            this.updateTabStates('_videoSettingTab');
        }
    
        return errorCount;
    }
    
    handleVideoSettingTab(returnData: any, redirect: boolean, ikParameter: any): number {
        let errorCount = this.processErrorMessages(returnData, this._videoSettingTabErrorProperty, 0, false);
    
        if (this.props.isProjectSubActivity) {
            if (errorCount === 0 && redirect) {
                ikParameter.submitForm();
            }
        } else if (errorCount === 0 && redirect) {
            if (!this.state.videoQuestionStatus) {
                this.updateTabStates('_activitySettingTab');
            } else {
                this.updateTabStates('_videoContentTab');
            }
        }
    
        return errorCount;
    }
    
    handleVideoContentTab(returnData: any, redirect: boolean): { errorCount: number, videoQuestionValidate: boolean } {
        let errorCount = this.processErrorMessages(returnData, this._videoContentTabErrorProperty, 0, false);
        let videoQuestionValidate = this.checkQuestionValidation();
    
        if (errorCount === 0 && redirect && videoQuestionValidate) {
            this.updateTabStates('_activitySettingTab');
        }
    
        return { errorCount, videoQuestionValidate };
    }
    
    handleActivitySettingTab(returnData: any, redirect: boolean, ikParameter: any): number {
        let errorCount = this.processErrorMessages(returnData, null, 0, true);
    
        if (errorCount === 0 && redirect) {
            ikParameter.submitForm();
        }
    
        return errorCount;
    }

    public async beforeClickForm(ikParameter: FormikProps<actionTypeVideo.IVideoInsertData>, redirect: boolean): Promise<boolean> {

        ikParameter.values.isFileUploadEmpty = checkFileUploadEmpty(this.state.deletedFile);
        if(this.state.deletedFile)
        {
            Notification.setNotification(
                'error',
                T.t('r_validation_gen_video'),
                'topRight'
            );
            return false;
        }
        let videoQuestionValidate = true;

        if(ikParameter.values.dateCriteria === 2)  
            {
                if(!ikParameter.values.datePrerequisiteActivityId || ikParameter.values.datePrerequisiteActivityId[0] == null)
                {
    
                    Notification.setNotification(
                        'error',
                        T.t('r_validation_gen_datePrerequisiteActivityId')+ " - "+ T.t('r_selection_required_validation'),
                        'topRight'
                    );

                    return false;
                }
    
            }
       
       
        const returnValue = await ikParameter
            .validateForm()
            .then((returnData: any) => {
                let errorCount = 0;
                let videoQuestionValidate = true;

                if (this._selectClassTab?.current?.getAttribute('data-current') === 'true') {
                    errorCount = this.handleSelectClassTab(returnData, redirect);
                } else if (this._videoSettingTab.current?.getAttribute('data-current') === 'true') {
                    errorCount = this.handleVideoSettingTab(returnData, redirect, ikParameter);
                } else if (this._videoContentTab.current?.getAttribute('data-current') === 'true') {
                    const result = this.handleVideoContentTab(returnData, redirect);
                    errorCount = result.errorCount;
                    videoQuestionValidate = result.videoQuestionValidate;
                } else if (this._activitySettingTab.current?.getAttribute('data-current') === 'true') {
                    errorCount = this.handleActivitySettingTab(returnData, redirect, ikParameter);
                }

                return errorCount === 0 && videoQuestionValidate;
            })
            .then((validateResult: boolean) => {

                return validateResult;
            });

        return returnValue;
    }

    getValidation = () => {
        if (this.props.coursePageclassInformation &&
            this.props.coursePageclassInformation.isWeekly === true &&
            this.props.coursePageclassInformation.startDate &&
            this.props.coursePageclassInformation.endDate) {
            return getValidation({
                isProjectSubActivity: this.props.isProjectSubActivity,
                startDate: this.props.coursePageclassInformation.startDate,
                endDate: this.props.coursePageclassInformation.endDate,
                dateFormat: _common.findDateFormat(this.props.userPreferences!),
                isUploaded: this.state.isUploaded
            });
        } else {
            return getValidation({ isProjectSubActivity: this.props.isProjectSubActivity, isUploaded: this.state.isUploaded });
        }
    }

    setCloseModal = () => {
        this.props.setCloseModal(ActivityType.Video);
        this.props.dispatch(Actions.setVideoQuestionDataDefault());
    };

    fileOrFileEmbedUploaded = () => {
        this.setState({ isUploaded: true });
        this.setState({ deletedFile: false });

    };

    fileOrFileEmbedDelete = () => {
        this.setState({ deletedFile: true });
    };

    triggerModal = (assignedStudentDatas: ISetAssignmentStudentList, removedStudentDatas: ISetAssignmentStudentList, currentTab: string) => { };

    selectedClassIds = (selectedClassIds: any) => { };

    setInitialFormValues = (userDateFormat: string) => {
        const initialFormValues = {
            ...this.props.videoData!,
            taskDeadline:
                this.props.videoData && this.props.videoData.taskDeadline
                    ? Moment(this.props.videoData.taskDeadline.toString())
                        .format(userDateFormat)
                        .toString()
                    : '',
            taskDeadlinetime:
                this.props.videoData && this.props.videoData.taskDeadline
                    ? Moment(this.props.videoData.taskDeadline.toString())
                        .format(window.appSettings.DefaultDateTimeFormat)
                        .toString()
                    : '',
            activityBeginDate:
                this.props.videoData!.activityConditionalBeginDate
                    ? Moment(this.props.videoData!.activityConditionalBeginDate.toString())
                        .format(userDateFormat)
                        .toString()
                    : '',
            activityBeginTime:
                this.props.videoData!.activityConditionalBeginDate
                    ? Moment(this.props.videoData!.activityConditionalBeginDate).format('HH:mm')
                        .toString()
                    : '',
            activityEndDate:
                this.props.videoData!.activityConditionalEndDate
                    ? Moment(this.props.videoData!.activityConditionalEndDate.toString())
                        .format(userDateFormat)
                        .toString()
                    : '',
            activityEndTime:
                this.props.videoData!.activityConditionalEndDate
                    ? Moment(this.props.videoData!.activityConditionalEndDate).format('HH:mm')
                        .toString()
                    : '',
            dateFormat: userDateFormat,
            fileInputKey: Guid.create().toString(),
            photoUploadKey: Guid.create().toString(),
            isAllClass: this.props.updateActivityId && this.props.videoData ? this.props.videoData.isAllClass : this.props.isSingleClass,
            isActivityPrerequisite: this.props.videoData!.prerequisiteActivityId && this.props.videoData!.prerequisiteActivityId.length > 0,
            isCommon: this.props.videoData!.isCommon
        };
        return initialFormValues;
    }

    renderFooter = (props: any) => {

        let renderText = null;
        if(this.state.currentTab === '_activitySettingTab' || this.props.isProjectSubActivity){
            if(this.state.isLoadingProcess){
                renderText = T.t('r_gen_sharing')
            }else{
                renderText = T.t('r_save_button')
            }
        }else {
            renderText = (
                <React.Fragment>
                    {T.t('r_continue_button')}
                    <i className="material-icons ml-2">arrow_forward</i>
                </React.Fragment>
            )
        }
        
        return(
            <div className="modal-footer d-block">
                <div className="row">
                    <div className="col-md">
                        <button type="button" onClick={this.setCloseModal} className="btn btn-gray">
                            {T.t('r_cancel_button')}
                        </button>
                    </div>
                    <div className="col-md text-md-right">
                        <button
                            onClick={() => this.beforeClickForm(props, true)}
                            type="button"
                            id={'btn-' + spinnerId}
                            className="btn btn-green ml-2"
                        >
                            {renderText}
                        </button>
                    </div>
                </div>
                <div className="row">
                    <Label>
                        {this.props.videoData!.abbreviation ?? ''}
                    </Label>
                </div>
            </div>
        )
    }

    renderTabContent = (userDateFormat: any) => {
        return(
            <div className="tab-content" id="tabContent">
            {   this.props.classes?.classes?.length > 0 &&
                <SelectClasses
                    coursePageActivityId={this.props.coursePageActivityId!}
                    currentTab={this.state.currentTab}
                    isUpdate={this.props.updateActivityId}
                    selectedClassIds={this.selectedClassIds}
                />
            }
            <VideoActivitySettings
                currentTab={this.state.currentTab}
                isUpdate={this.props.updateActivityId}
                dateFormat={userDateFormat}
                isWeekly={
                        this.props.coursePageclassInformation?.isWeekly
                        ? this.props.coursePageclassInformation.isWeekly
                        : false
                }
                coursePageActivityId={this.props.coursePageActivityId!}
                coursePageClassId={this.props.coursePageClassId!}
                fileInputKey={this.state.fileInputKey}
                isProjectSubActivity={this.props.isProjectSubActivity}
                fileOrFileEmbedUploaded={this.fileOrFileEmbedUploaded}
                termType={this.props.termType ?? T.t('r_time_week')}
                updateVideoQuestionStatus={this.updateVideoQuestionStatus}
                activityType={ActivityType.Video}
                fileOrFileArciveLinkDelete={this.fileOrFileEmbedDelete}

            />
            <VideoContentPanel currentTab={this.state.currentTab} />
            <ActivitySettings
                removedStudentDatas={{ users: [], filters: {}, type: '', timestamp: 0 }}
                assignedStudentDatas={{ users: [], filters: {}, type: '', timestamp: 0 }}
                currentTab={this.state.currentTab}
                coursePageActivityId={this.props.coursePageActivityId!}
                coursePageClassId={this.props.coursePageClassId!}
                displayAllowDownloadSetting={true}
                isActivityCardShown={false}
                setCloseModal={this.triggerModal}
                triggerModal={this.triggerModal}
                isUpdate={this.props.updateActivityId}
                activityType={ActivityType.Video}
            />
        </div>
        )
        
    }

    setClassName = (currentTab: string) => {
        return(this.state.currentTab === currentTab
            ? 'nav-link active'
            : 'nav-link ')
    }

    renderTabs = (props: any) => {
        return(
            !this.props.isProjectSubActivity ? (
                <ul className="nav nav-tabs border-0" style={{ paddingInlineStart: '0px' }} id="tabs">
                    {
                        this.props.classes?.classes?.length > 0 &&
                        <li className="nav-item" style={{ display: this.props.isSingleClass ? 'none' : 'table-cell' }}>
                            <a 
                                className={
                                this.setClassName('_selectClassTab')}
                                data-current={this.props.isSingleClass || this.props.classes?.classes?.length === 0 ? 'false' : 'true'}
                                ref={this._selectClassTab}
                                onClick={() => this.onTabClick(props, '_selectClassTab')}
                                id="select-class-tab"
                            >
                                {T.t('r_tab_branch')}
                            </a>
                        </li>
                    }

                    <li className="nav-item">
                        <a
                            className={this.setClassName('_videoSettingTab')}
                            id="video-setting-tab"
                            data-current={this.props.isSingleClass || this.props.classes?.classes?.length === 0 ? 'true' : 'false'}
                            ref={this._videoSettingTab}
                            onClick={() => this.onTabClick(props, '_videoSettingTab')}
                        >
                            {T.t('r_tab_detail')}
                        </a>
                    </li>
                    <li
                        className={
                            !this.state.videoQuestionStatus ?
                                'hidden-tab nav-item'
                                : 'nav-item'
                        }>
                        <a id="video-tab"
                            data-current={'false'}
                            ref={this._videoContentTab}
                            onClick={() => this.onTabClick(props, '_videoContentTab')}
                        >
                            {T.t('r_tab_questions')}
                        </a>
                    </li>

                    <li className="nav-item">
                        <a
                            className={this.setClassName('_activitySettingTab')}
                            id="activity-setting-tab"
                            data-current={'false'}
                            ref={this._activitySettingTab}
                            onClick={() => this.onTabClick(props, '_activitySettingTab')}
                        >
                            {T.t('r_tab_settings')}
                        </a>
                    </li>
                </ul>
            ) : (
                <div>
                    <span id="select-class-tab" ref={this._selectClassTab} data-current={'false'} />
                    <span id="video-setting-tab" ref={this._videoSettingTab} data-current={'true'} />
                    <span id="video-tab" ref={this._videoContentTab} data-current={'false'} />
                    <span id="activity-setting-tab" ref={this._activitySettingTab} data-current={'false'} />
                </div>
            )
        )
    }

    public render() {
        const userDateFormat: string = _common.findDateFormat(this.props.userPreferences);
        
        const initialFormValues = this.setInitialFormValues(userDateFormat);
        return (
            <Modal
                isOpen={this.props.isModalOpen}
                toggle={this.setCloseModal}
                modalClassName={'add-activity-modal modal-from-right slideInRight show animated'}
                fade={true}
                style={{ display: 'block', animationDuration: '0.5s' }}
                backdrop={'static'}
            >
                <div className="modal-dialog" role="document">
                    {(this.props.updateActivityId && initialFormValues.activityId) || !this.props.updateActivityId ? (
                        <Formik
                            initialValues={initialFormValues}
                            validationSchema={this.getValidation}
                            onSubmit={this.onSubmit}
                            // tslint:disable-next-line
                            render={props => (
                                <form onSubmit={props.handleSubmit}>
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title d-flex align-items-center">
                                                <i className="material-icons mr-2">{_common.GetMaterialActivityIcons(ActivityType.Video)}</i>

                                             <span>{this.props.updateActivityId ? T.t('r_edit_video_activity') : T.t('r_add_video_activity')}</span>

                                            </h5>
                                            <button
                                                onClick={this.setCloseModal}
                                                type="button"
                                                className="close"
                                                data-dismiss="modal"
                                                aria-label="Close"
                                            >
                                                <i style={{ color: '#000' }} className="material-icons">
                                                    close
                                                </i>
                                                <span>{T.t('r_gen_close')}</span>
                                            </button>
                                        </div>
                                        <div className="modal-body p-0">
                                            <Loading width={100} spinnerId={spinnerId} />

                                            {this.renderTabs(props)}

                                            {this.renderTabContent(userDateFormat)}

                                        </div>
                                        {(this.renderFooter(props))}
                                    </div>
                                </form>
                            )}
                        />
                    ) : (
                        ''
                    )}
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (State: IAppState, ownProps: IAddVideo): IAddVideo => {
    if (!State) {
        return ownProps;
    }

    const videoObj: any = State.video;

    const newProps: IAddVideo = Object.assign({}, ownProps, {
        videoData: videoObj.videoData,
        questionData: videoObj.questionData,
        coursePageActivityId: State.coursePage.coursePageActivityId,
        coursePageClassId: State.coursePage.coursePageClassId,
        coursePageclassInformation: State.coursePage.coursePageclassInformation,
        userPreferences: State.profile.userPreferences.preferences,
        initialTermWeekId: State.coursePage.courseContentTermWeeks && State.coursePage.courseContentTermWeeks[0].termWeekId,
        termType: State.coursePage.courseContentTermWeeks?.[1]?.termType ?? null,
        activityCard: State.coursePage.activityCard,
        classes: State.coursePage.classes
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.video.videoData === prev.video.videoData &&
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.profile.userPreferences === prev.profile.userPreferences;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CAddVideo = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(AddVideo);

export default CAddVideo;
